import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import { ActivityService } from "../../globals/services/activity.service";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showLoader } from "../../store/actions/mainActions";
import moment from "moment";

export const Activity = (props) => {
  const [activities, setActivities] = useState([]);
  const dispatch = useDispatch();
  const columns = [
    {
      dataField: "userDetails[0].firstName",
      formatter: (value, row) => {
        return row.userDetails.length > 0
          ? `${row.userDetails[0].firstName} ${row.userDetails[0].lastName}`
          : "User Not Found";
      },
      text: "USER NAME",
      sort: true,
    },
    {
      dataField: "userDetails[0].email",
      text: "USER EMAIL",
      sort: true,
    },
    {
      dataField: "device",
      text: "Device",
      sort: true,
      formatter: (cell) => {
        return cell!==undefined && (cell.includes('Android') || cell.includes('iPhone')) ? "Mobile" : "Web";
      }
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: true,
    },
    {
      dataField: "ci[0].title",
      text: "ITEM CHANGED",
      sort: true,
    },
    {
      dataField: "time",
      text: "DATE",
      sort: true,
      formatter: (cell) => {
        return moment(new Date(parseInt(cell))).format("DD/MM/YYYY hh:mm")
      },
    },
  ];

  useEffect(() => {
    const getActivities = async () => {
      try {
        dispatch(showLoader(true));
        const activityService = ActivityService();
        const _activities = await activityService.get();
        console.log(_activities.length);
        setActivities(_activities);
        dispatch(showLoader(false));
      } catch (err) {
        dispatch(showLoader(false));
        console.error(err);
      }
    };
    getActivities();
  }, [setActivities, dispatch]);

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MAIN" breadcrumbItem="HARTMAN ACTIVITY" />
          <DatatableTables
            columns={columns}
            data={activities}
            title={"Content Items"}
            desc={"Recent Items in Hartman Connect"}
          ></DatatableTables>
        </div>
      </div>
    </div>
  );
};
